import { Container } from './styles'
import powerBI from '../../assets/visuals/power-bi-dashboard.png'
import thesisLaz from '../../assets/visuals/thesis-laz.png'
import thesisSegmentation from '../../assets/visuals/thesis-segmentation.png'

type VisualItem = {
  title: string
  description: string
  image: string
  alt: string
  tag: string
}

const visuals: VisualItem[] = [
  {
    title: 'Power BI Dashboard',
    description: 'Exploratory analytics and executive-ready visuals for business outcomes.',
    image: powerBI,
    alt: 'Power BI dashboard with charts and KPIs',
    tag: 'Power BI',
  },
  {
    title: 'LAZ File - Chicago Downtown',
    description: 'Labeled LiDAR data prepared for instance segmentation of tall buildings.',
    image: thesisLaz,
    alt: 'LAZ file view of Chicago downtown',
    tag: 'Thesis',
  },
  {
    title: 'Instance Segmentation Output',
    description: 'Model results highlighting segmented structures for the thesis study.',
    image: thesisSegmentation,
    alt: 'Instance segmentation visualization',
    tag: 'Thesis',
  },
]

export function Visuals() {
  return (
    <Container id="visuals">
      <div className="section-header">
        <p className="eyebrow">Power BI & Thesis</p>
        <h2>Visual Highlights</h2>
        <p className="muted">
          Selected dashboards and research visuals from my portfolio and thesis work.
        </p>
      </div>

      <div className="visual-grid">
        {visuals.map((item) => (
          <article className="visual-card" key={item.title}>
            <div className="image-frame">
              <img src={item.image} alt={item.alt} loading="lazy" />
              <span className="tag">{item.tag}</span>
            </div>
            <div className="card-body">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </Container>
  )
}
